import { Head, useForm, usePage } from "@inertiajs/react";
import { LoaderCircle } from "lucide-react";
import type { FormEventHandler } from "react";

import InputError from "@/components/input-error";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import AuthLayout from "@/layouts/auth-layout";
import { identityPasswordSetupPath } from "@/routes";
import type { SharedData } from "@/types";

interface PasswordSetupForm {
  password: string;
  password_confirmation: string;
}

export default function PasswordSetup() {
  const { auth } = usePage<SharedData>().props;
  const { data, setData, put, processing, errors, reset } =
    useForm<PasswordSetupForm>({
      password: "",
      password_confirmation: "",
    });

  const submit: FormEventHandler = (e) => {
    e.preventDefault();
    put(identityPasswordSetupPath(), {
      onFinish: () => reset("password", "password_confirmation"),
    });
  };

  return (
    <AuthLayout
      title="Configurá tu contraseña"
      description="Creá una contraseña para poder ingresar la próxima vez sin depender del correo electrónico"
    >
      <Head title="Configurar contraseña" />

      <form onSubmit={submit}>
        <div className="grid gap-6">
          <div className="grid gap-2">
            <Label htmlFor="email">Correo electrónico</Label>
            <Input
              id="email"
              type="email"
              value={auth?.user?.email || ""}
              className="mt-1 block w-full"
              readOnly
              disabled
            />
          </div>

          <div className="grid gap-2">
            <Label htmlFor="password">Nueva contraseña</Label>
            <Input
              id="password"
              type="password"
              autoComplete="new-password"
              value={data.password}
              autoFocus
              onChange={(e) => setData("password", e.target.value)}
              placeholder="Mínimo 8 caracteres"
            />
            <InputError message={errors.password} />
          </div>

          <div className="grid gap-2">
            <Label htmlFor="password_confirmation">Confirmar contraseña</Label>
            <Input
              id="password_confirmation"
              type="password"
              autoComplete="new-password"
              value={data.password_confirmation}
              onChange={(e) => setData("password_confirmation", e.target.value)}
              placeholder="Repetí la contraseña"
            />
            <InputError message={errors.password_confirmation} />
          </div>

          <Button type="submit" className="mt-4 w-full" disabled={processing}>
            {processing && <LoaderCircle className="h-4 w-4 animate-spin" />}
            Guardar contraseña y continuar
          </Button>
        </div>
      </form>
    </AuthLayout>
  );
}
